export default __webpack_public_path__ + "static/media/portPopUp.d4730c4a.svg";